
/** 获取首页进入信息 */
export const HOME_PAGE_URL = `${ENV.POSMOBILE}/homePage/homePage`
/** 获取首页推荐信息 */
export const HOME_RECOMMEND_URL = `${ENV.POSMOBILE}/product/listRecommendHome`
/** 获取购物车推荐信息 */
export const CART_RECOMMEND_URL = `${ENV.POSMOBILE}/product/listRecommendCart`
/** 微信小程序用户注册、查询 */
export const WECHAT_MINI_LOGIN_API = `${ENV.MEMBER}/login/miniapp`
/** 微信公众号是否可以授权 */
export const MP_STATUS_BY_BRAND_ID = `${ENV.AUTH}/wx/getMpStatusByBrandId`
/** 微信公共号用户注册、查询 */
export const WECHAT_LOGIN_API = `${ENV.MEMBER}/login/wechat`
/** 多人点餐websocket连接 */
export const MULTI_PERSON_SERVER_URL = ENV.REDISDB
/** 多人点餐服务数据操作接口 */
export const EMIT_MUTI_CART_API = `${ENV.ORDERJMOBILE}/castInRoom`
/** 多人点餐服务数据操作接口 */
export const SAVE_MUTI_CART_API = `${ENV.ORDERJMOBILE}/saveMultiCart`
/** 多人点餐服务数据操作接口(批量) */
export const SAVE_MUTI_CART_BATCH_API = `${ENV.ORDERJMOBILE}/saveMultiCartTogo`
/** 多人点餐服务数据获取接口 */
export const LIST_MULTI_CART_API = `${ENV.ORDERJMOBILE}/listMultiCart`
/** 多人点餐服务数据清空接口 */
export const CLEAR_MULTI_CART_API = `${ENV.ORDERJMOBILE}/clearMultiCart`
/** 多人点餐服务删除房间 */
export const DEL_MULTI_ROOM_API = `${ENV.ORDERJMOBILE}/delRoom`
/**
 * 拼单
 */
/** 多人点餐服务删除房间 */
export const CREATE_ROOM = `${ENV.ORDERJMOBILE}/createRoom`
